import { has, Props } from "wasabi-common";

export default class Preferences {
  private static readonly STORAGE_KEY = "tvm.media";
  private static readonly STORAGE_BACKUP_KEY = "storage_backup_key";
  public static readonly STORAGE_GROUP_KEY = "storage_group_key";

  public static getString(name: string, defaultValue: string) {
    const result = Preferences.getItem(name);
    return has(result) ? result : defaultValue;
  }

  public static setString(name: string, value: string) {
    Preferences.setItem(Preferences.getKey(name), value);
  }

  public static getNumber(name: string, defaultValue: number) {
    const result = Preferences.getItem(name);
    return has(result) ? Number(result) : defaultValue;
  }

  public static setNumber(name: string, value: number) {
    Preferences.setItem(Preferences.getKey(name), value);
  }

  public static getDate(name: string, defaultValue: Date) {
    const result = Preferences.getItem(name);
    return has(result) ? new Date(Number(result)) : defaultValue;
  }

  public static setDate(name: string, value: Date) {
    Preferences.setItem(Preferences.getKey(name), value ? value.getTime() : null);
  }

  public static getJson<T extends Props<any>>(name: string, defaultValue: T) {
    const result = Preferences.getItem(name);
    return has(result) ? JSON.parse(result) : defaultValue;
  }

  public static setJson<T extends Props<any>>(name: string, props: T) {
    Preferences.setItem(Preferences.getKey(name), props ? JSON.stringify(props) : null);
  }

  public static getItem(name: string) {
    const result = localStorage.getItem(Preferences.getKey(name));
    return has(result) ? result : null;
  }

  public static setItem(name: string, value: any) {
    if (has(value)) {
      localStorage.setItem(name, value.toString());
    } else {
      localStorage.removeItem(name);
    }
  }

  public static getKey(name: string): string {
    return `${Preferences.STORAGE_KEY}-${name}`;
  }

  public static getAll() {
    const allProps: Props<string> = {};
    for (let i = 0; i < localStorage.length; i = i + 1) {
      const key = localStorage.key(i);
      if (key !== Preferences.getKey(Preferences.STORAGE_BACKUP_KEY)) {
        allProps[key] = localStorage[key];
      }
    }
    return allProps;
  }

  public static backupAndClear() {
    const allProps = Preferences.getAll();
    this.clear();
    this.setJson(Preferences.STORAGE_BACKUP_KEY, allProps);
  }

  public static clear() {
    localStorage.clear();
  }

  public static hasBackUp() {
    const backup = Preferences.getJson(Preferences.STORAGE_BACKUP_KEY, null);
    return !!backup;
  }

  public static getGorupKey(): String {
    const groupKey = Preferences.getString(Preferences.STORAGE_GROUP_KEY, null);
    return groupKey;
  }

  public static restoreBackup() {
    const backup = Preferences.getJson(Preferences.STORAGE_BACKUP_KEY, null);
    if (backup) {
      Preferences.clear();
      for (const key in backup) {
        localStorage.setItem(key, backup[key]);
      }
    }
  }
}
